import { useState } from "react";
import {
  TENANT_LOGO_KIND,
  brandName,
  brandUrl,
  isUploadedIcon,
} from "@/helpers/brandIcons";

// Bağlantı simgesi. Dört ihtimal var:
//
//   tenant-logo    — bağlantı kiracının KENDİ alan adına gidiyor (helpers/branchLinks isTenantSite).
//                    Markanın kendi amblemi jenerik bir küreden çok daha tanınır.
//   brand:<ad>     — panelde seçilen marka simgesi (Instagram, WhatsApp, Gmail…). Görsel bu
//                    uygulamanın public/brands klasöründen geliyor.
//   https://…      — kiracının kendi yüklediği simge (R2). Hazır setin dışına çıkmanın yolu.
//   diğer her şey  — kullanıcının seçtiği emoji, olduğu gibi basılıyor. VARSAYILAN yol bu.
//
// Eski sabit tür listesine (phone/instagram/…) bağlı SVG'ler kaldırıldı; artık hepsi
// public/brands altında dosya olarak duruyor ve panelde de aynı dosyalar kullanılıyor.

// Kiracının kendi amblemi: kare simge varsa o, yoksa yükleme görseli, sonra logo, en sonda statik
// küre. onError zinciri yürütüyor, yani 404 dönen kaynak bir sonrakine düşüyor.
function TenantLogo({ markUrl, loadingImageUrl, logoUrl, size }) {
  const sources = [markUrl, loadingImageUrl, logoUrl].filter(Boolean);
  const [index, setIndex] = useState(0);
  const src = sources[index];

  if (!src) {
    return (
      <img
        src={brandUrl("website")}
        alt="Web Sitesi"
        width={size}
        height={size}
      />
    );
  }

  return (
    <img
      src={src}
      alt="Web Sitesi"
      width={size}
      height={size}
      style={{ objectFit: "contain", borderRadius: 4 }}
      onError={() => setIndex((current) => current + 1)}
    />
  );
}

// `size` yalnızca şube kartındaki etiketli çip için: orada simge 12.5px'lik metnin yanında duruyor
// ve 20px onu eziyor. Diğer her yerde varsayılan geçerli.
export default function BrandIcon({
  kind,
  markUrl,
  logoUrl,
  loadingImageUrl,
  size = 20,
}) {
  if (kind === TENANT_LOGO_KIND) {
    return (
      <TenantLogo
        markUrl={markUrl}
        loadingImageUrl={loadingImageUrl}
        logoUrl={logoUrl}
        size={size}
      />
    );
  }

  const brand = brandName(kind);

  if (brand) {
    return <img src={brandUrl(brand)} alt="" width={size} height={size} />;
  }

  if (isUploadedIcon(kind)) {
    return (
      <img
        src={kind}
        alt=""
        width={size}
        height={size}
        style={{ objectFit: "contain" }}
      />
    );
  }

  return <span className="contact-icon__emoji">{kind}</span>;
}
